<form [formGroup]="resultsAppropriationStatementFg">
  <div class="row">
    <div class="col col-1 pt-3" style="width: 400px">
      <p style="padding: 6px">Opgave van de bestemming van de winst of de verwerking van het verlies</p>
    </div>
    <div class="col-2 pt-3">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.resultsAppropriationStatementFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(2)">
        {{ this.resultsAppropriationStatementFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    @if (isRechtspersoon) {
      <div class="col-3">
        <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                          label="In publicatiestukken"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </div>
</form>

<form [formGroup]="resultsAppropriationProposalStatementFg">
  <div class="row">
    <div class="col col-1" style="width: 400px">
      <p style="padding: 6px">Opgave van het voorstel voor de bestemming van de winst of de verwerking van het
        verlies</p>
    </div>
    <div class="col-2">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.resultsAppropriationProposalStatementFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(3)">
        {{ this.resultsAppropriationProposalStatementFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    @if (isRechtspersoon) {
      <div class="col-3">
        <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </div>
</form>

<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.resultsAppropriationStatementFg"
                                                               [title]="'Opgave van de bestemming van de winst of de verwerking van het verlies'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.resultsAppropriationProposalStatementFg"
                                                               [title]="'Opgave van het voorstel voor de bestemming van de winst of de verwerking van het verlies'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

